var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 562,
    width: 96,
    height: 96
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-352 -562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431 637.021 431 634 428 634 428 603 431 603 431 598 436 598 436 596 400 574 364 596 364 598 369 598 369 603 372 603 372 634 369 634 369 637.021 362 642.021 362 646 438 646 438 642.022ZM426 634 422 634 422 603 426 603ZM380 603 388 603 388 634 380 634ZM390 603 394 603 394 634 390 634ZM396 603 404 603 404 634 396 634ZM406 603 410 603 410 634 406 634ZM412 603 420 603 420 634 412 634ZM367.866 595.981 400 576.347 432.134 595.981C432.139 595.983 432.142 595.988 432.14 595.994 432.139 595.997 432.137 595.999 432.134 596L367.872 596C367.866 595.999 367.862 595.994 367.862 595.988 367.863 595.985 367.864 595.983 367.866 595.981ZM371 598 429 598 429 601 371 601ZM374 603 378 603 378 634 374 634ZM371 638.05 371 636 429 636 429 638.05 429.837 638.65 430.329 639.002 369.671 639.002 370.163 638.65ZM436 644 364 644 364 643.052 366.871 641 433.132 641 436 643.052Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.234f2c2576259af2cf620dff2cc865ee.svg";
export { ForwardRef as ReactComponent };